import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget/jackpot-widget.component";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {JackpotBetWidgetBgDefaultBox} from "./jackpot-bet-widget-bg.default.box";
import {JackpotBetWidgetBgMRGBox} from "./jackpot-bet-widget-bg.mrgreen.box";
import {JackpotBetWidgetBg777Box} from "./jackpot-bet-widget-bg.777.box";

export interface IJackpotBetWidgetBgBoxProps {
    layout: JACKPOT_WIDGET_LAYOUT;
}

export const JackpotBetWidgetBgBox = styledByTheme(JackpotBetWidgetBgDefaultBox)
    .forMrGreen(JackpotBetWidgetBgMRGBox)
    .forCasino777(JackpotBetWidgetBg777Box)
    .apply();
